<template>
  <div>
    <v-container>
      <h1>{{title}}</h1>
       <v-row>
        <v-col cols="12" md="4" offset-md="8" xs="12" sm="6" offset-sm="6">
          <v-text-field label="Search" v-model="search"></v-text-field>
        </v-col>
      </v-row>
      <v-data-table :items="items" :headers="headers" :search="search">
        <template v-slot:item.actions="{item}">
          <v-btn
            icon
            text
            :to="
              `/onboarding-plan-status/${item.transactionNo}`
            "
          >
            <v-icon>mdi-arrow-right-bold</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-container>
  </div>
</template>
<script>
import { headers } from "./variables"
export default {
  metaInfo: {
    title: "Onboarding Plan Status View ",
    titleTemplate: `%s - ${process.env.VUE_APP_NAME}`
  },
  data: () => ({
    title: "Onboarding Plan Status View",
    items: [],
    headers,
    search: null
  }),
  methods: {
    getList() {
      this.$axios.get(`/api/onboarding/status`)
        .then(({ data }) => {
          this.items = data;
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message)
        })
    }
  },
  created() {
    this.getList();
  }
}
</script>